import { useLocation } from "react-router-dom";
import { Spin } from "antd";

import { useVerifyUserInviteEmailQuery } from "@/redux/service";
import AdminInviteRegister from "./AdminInviteRegister";
import SingleStepRegister from "./SingleStepRegister";

const InviteRegister = () => {
  const { search } = useLocation();
  const token = new URLSearchParams(search).get("token") ?? "";

  const { data, isFetching } = useVerifyUserInviteEmailQuery(token, {
    skip: !token,
  });

  if (isFetching) {
    return (
      <div className="flex justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (data?.adminInvite) {
    return <AdminInviteRegister />;
  }

  return <SingleStepRegister useVerifyToken={useVerifyUserInviteEmailQuery} />;
};

export default InviteRegister;
